import React from 'react'
import Image from '../../../helpers/Image/Image'
import * as Styled from './ugc.styles'

const PLPPanel = ({ link, dataTest, imageUrl, name }) => (
  <Styled.PanelContainer href={link} data-test={`${dataTest}-panel`}>
    <Styled.Thumbnail>
      {imageUrl && (
        <Image src={imageUrl} alt={name} data-test={`${dataTest}-image`} width={70} height={70} cdn={false} />
      )}
    </Styled.Thumbnail>
    <Styled.Details>
      <Styled.Name data-test={`${dataTest}-name`}>{name}</Styled.Name>
      <Styled.MoreDetails>
        <Styled.LargerButton small kind='secondary' data-test={`${dataTest}-button-more-details`}>
          View More
        </Styled.LargerButton>
      </Styled.MoreDetails>
    </Styled.Details>
  </Styled.PanelContainer>
)

export default PLPPanel
